import React from "react";

const GlobeIcon = (props) => {
  return (
    <svg
      width="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0Zm8.32 18.213a15.393 15.393 0 0 0-3.155-1.412 24.94 24.94 0 0 0 .417-4.001h4.776a10.311 10.311 0 0 1-2.038 5.413zM1.64 12.8h4.777c.04 1.426.181 2.773.417 4a15.39 15.39 0 0 0-3.154 1.414A10.321 10.321 0 0 1 1.64 12.8Zm2.04-7.013a15.404 15.404 0 0 0 3.154 1.412 25.04 25.04 0 0 0-.416 4.001H1.64a10.32 10.32 0 0 1 2.04-5.413Zm11.566.277A15.661 15.661 0 0 1 12 6.4c-1.112 0-2.2-.114-3.245-.336C9.537 3.289 10.81 1.6 12 1.6c1.19 0 2.463 1.689 3.246 4.464zm.016-3.932a10.409 10.409 0 0 1 3.99 2.429c-.776.437-1.6.795-2.46 1.078-.39-1.393-.909-2.584-1.53-3.507ZM8.017 11.2c.039-1.293.171-2.494.376-3.578C9.557 7.872 10.765 8 12 8c1.235 0 2.443-.129 3.607-.378.205 1.083.336 2.284.376 3.578zm7.966 1.6a23.136 23.136 0 0 1-.376 3.578A17.242 17.242 0 0 0 12 16c-1.235 0-2.443.129-3.607.378a23.199 23.199 0 0 1-.376-3.578zM7.207 5.64a13.84 13.84 0 0 1-2.46-1.08 10.398 10.398 0 0 1 3.99-2.428c-.62.922-1.139 2.113-1.53 3.507Zm0 12.72c.391 1.394.91 2.585 1.53 3.508a10.409 10.409 0 0 1-3.99-2.429c.776-.437 1.601-.795 2.46-1.078zm1.547-.424A15.661 15.661 0 0 1 12 17.6c1.112 0 2.2.114 3.246.336C14.463 20.711 13.19 22.4 12 22.4s-2.463-1.689-3.246-4.464zm8.039.425c.86.283 1.684.641 2.46 1.078a10.398 10.398 0 0 1-3.99 2.429c.62-.923 1.139-2.114 1.53-3.507zm.79-7.161a25.04 25.04 0 0 0-.417-4 15.413 15.413 0 0 0 3.155-1.414A10.328 10.328 0 0 1 22.36 11.2z"
        fill={props.color || "currentColor"}
        strokeWidth=".0457143"
      />
    </svg>
  );
};

export default GlobeIcon;
